import { useState } from 'react'
import { filterAdmissions } from '../utils/filters'

const useAdmissionFilters = (admissionsData) => {
  const [searchText, setSearchText] = useState('')
  const [dateRange, setDateRange] = useState(null)
  const [statusFilter, setStatusFilter] = useState('all')
  const [departmentFilter, setDepartmentFilter] = useState('all')

  // Get unique departments for filter dropdown
  const departments = [...new Set(admissionsData.map((admission) => admission.department))].sort()

  // Get filtered data based on current filters
  const filteredData = filterAdmissions(admissionsData, searchText, statusFilter, departmentFilter, dateRange)

  return {
    searchText,
    setSearchText,
    dateRange,
    setDateRange,
    statusFilter,
    setStatusFilter,
    departmentFilter,
    setDepartmentFilter,
    departments,
    filteredData
  }
}

export default useAdmissionFilters
